const TabPane = () => null;
if (process.env.NODE_ENV !== 'production') {
  TabPane.displayName = 'DeprecatedTabPane';
}
export default TabPane;


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/tabs/TabPane.js
// module id = 2577
// module chunks = 0